import { render, staticRenderFns } from "./KalturaVideoShow.vue?vue&type=template&id=fa689ef2&"
import script from "./KalturaVideoShow.vue?vue&type=script&lang=ts&"
export * from "./KalturaVideoShow.vue?vue&type=script&lang=ts&"
import style0 from "./KalturaVideoShow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports